var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/global.js
// module id = ./node_modules/webpack/buildin/global.js
// module chunks = components-4.30.2-ea97ddc4895a37b6fe4fa162f475a037 components-4.30.2-30ff76cf38997a6935af25d80963059f components-4.30.2-c7a8c7394bc66ae923c6b99bcb187418 components-4.30.2-c011781d048ab903660b0648ceb103c0 components-4.30.2-9dd73dc5f2939f7f1c3caa55bd68bab6 components-4.30.2-83a34b50d564efae38d63ca283d0127a components-4.30.2-cf0b5c7a06f89d790fdfc5688857eb6e components-4.30.2-605f7313d539e78873c3f6e44560db30 components-4.30.2-5fecfdb8e3ba19680d23d7412ffb2050 components-4.30.2-5ea3df448b2d2ace57f287fa61a01272 components-4.30.2-591526004f3cd11ddcab282000aa5426 components-4.30.2-397797c9b5d96fea35bb20e140297c67 components-4.30.2-70bf6490b522a683e434f09656186555